(() => {
  const config = window.hinokPdpBnplConfig;
  if (!config || window.HinokPdpBnpl) return;
  const query = new URLSearchParams(location.search).get('bnpl_qa');
  const qa = config.qa || query !== null;
  const forced = config.qa && ['A', 'B'].includes(query) ? query : '';
  const key = 'hinok_pdp_bnpl_' + config.id + (qa ? '_qa' : '');
  const exposureKey = key + '_exposure';
  const uuid = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i;
  const pending = new Map();
  let assignment = null;
  let exposure = null;
  let renderedSignature = '';
  let sessionHooked = false;
  let attempts = 0;
  function active() {
    return config.enabled === true && config.eligible === true &&
      (config.qa || Number.isFinite(Date.parse(config.launch)) && Date.now() >= Date.parse(config.launch));
  }
  function permission() {
    try {
      const privacy = window.Shopify && Shopify.customerPrivacy;
      const sdk = window.posthog;
      if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') return null;
      if (!privacy.analyticsProcessingAllowed() || sdk?.has_opted_out_capturing?.() === true) return false;
      return sdk?.has_opted_out_capturing?.() === false && typeof sdk.get_session_id === 'function' ? true : null;
    } catch (error) { return null; }
  }
  function session() {
    if (permission() !== true) return '';
    try {
      const sid = posthog.get_session_id();
      return typeof sid === 'string' && /^[a-zA-Z0-9_.:-]{1,128}$/.test(sid) ? sid : '';
    } catch (error) { return ''; }
  }
  function assigned() {
    if (assignment) return assignment;
    try {
      let value = JSON.parse(localStorage.getItem(key) || 'null');
      if (!value || value.experiment !== config.id || !uuid.test(value.id) || !['A', 'B'].includes(value.variant) || forced && value.variant !== forced) {
        value = { experiment: config.id, id: crypto.randomUUID(), variant: forced || (crypto.getRandomValues(new Uint8Array(1))[0] < 128 ? 'A' : 'B') };
        localStorage.setItem(key, JSON.stringify(value));
      }
      assignment = value;
      return value;
    } catch (error) { return null; }
  }
  function clearExposure() {
    const hadExposure = Boolean(exposure || renderedSignature);
    exposure = null;
    renderedSignature = '';
    try { sessionStorage.removeItem(exposureKey); } catch (error) {}
    if (hadExposure) document.dispatchEvent(new CustomEvent('pdp-bnpl:changed'));
  }
  function valid(value, sid) {
    if (!value) return false;
    const allocated = assigned();
    return Boolean(value && allocated && value.experiment === config.id && value.assignment === allocated.id &&
      value.variant === allocated.variant && value.sid === sid && value.qa === qa && uuid.test(value.id) &&
      /^[a-z0-9][a-z0-9-]{0,199}$/.test(value.product) && Number.isFinite(Date.parse(value.at)) &&
      (config.qa || Date.parse(value.at) >= Date.parse(config.launch)));
  }
  function current(sid) {
    if (!active() || permission() !== true || !sid) return null;
    if (!exposure) {
      try { exposure = JSON.parse(sessionStorage.getItem(exposureKey) || 'null'); } catch (error) {}
    }
    if (valid(exposure, sid)) return exposure;
    clearExposure();
    return null;
  }
  function properties(value) {
    return {
      pdp_bnpl_ab_id: value.experiment, pdp_bnpl_ab_variant: value.variant,
      pdp_bnpl_ab_assignment: value.assignment, pdp_bnpl_ab_exposure: value.id,
      pdp_bnpl_ab_product: value.product, pdp_bnpl_ab_qa: value.qa,
      pdp_bnpl_ab_eligible: true, pdp_bnpl_ab_currency: 'USD', pdp_bnpl_ab_visible: value.variant === 'B'
    };
  }
  function refresh() {
    const root = document.querySelector('[data-pdp]');
    const form = root?.querySelector('[data-pdp-installments-form]');
    const allowed = permission();
    if (!active() || allowed !== true) {
      if (form) form.hidden = true;
      if (!active() || allowed === false) {
        clearExposure();
        pending.clear();
        if (allowed === false) {
          try { localStorage.removeItem(key); } catch (error) {}
          assignment = null;
        }
      }
      return null;
    }
    const sid = session();
    const previous = current(sid);
    if (!config.product) return previous;
    const offer = root?.hinokInstallmentOffer;
    if (!form || !offer?.eligible || !sid) {
      if (form) form.hidden = true;
      clearExposure();
      return null;
    }
    const allocated = assigned();
    form.hidden = !allocated || allocated.variant !== 'B';
    if (!allocated || document.visibilityState === 'hidden') return null;
    const signature = [sid, config.product, offer.variant, offer.total, offer.count].join(':');
    if (signature === renderedSignature && previous) return previous;
    const value = { experiment: config.id, variant: allocated.variant, assignment: allocated.id,
      id: crypto.randomUUID(), sid, qa, at: new Date().toISOString(), product: config.product };
    try { posthog.capture('pdp_bnpl_ab_exposure', properties(value)); } catch (error) {
      form.hidden = true;
      clearExposure();
      return null;
    }
    exposure = value;
    renderedSignature = signature;
    try { sessionStorage.setItem(exposureKey, JSON.stringify(value)); } catch (error) {}
    document.dispatchEvent(new CustomEvent('pdp-bnpl:changed'));
    return value;
  }
  window.HinokPdpBnpl = {
    cartAttributes(sid) {
      const value = current(sid);
      if (!value) return {};
      return {
        pdp_bnpl_ab_id: value.experiment, pdp_bnpl_ab_variant: value.variant,
        pdp_bnpl_ab_assignment: value.assignment, pdp_bnpl_ab_exposure: value.id,
        pdp_bnpl_ab_product: value.product, pdp_bnpl_ab_session: value.sid, pdp_bnpl_ab_qa: String(value.qa)
      };
    }
  };
  function initialize() {
    refresh();
    if (!sessionHooked && session() && typeof posthog.onSessionId === 'function') {
      sessionHooked = true;
      posthog.onSessionId(refresh);
    }
    if (attempts++ < 20 && active() && !sessionHooked) window.setTimeout(initialize, 500);
  }
  document.addEventListener('pdp:installments-change', refresh);
  document.addEventListener('cart:add', event => {
    const detail = event.detail || {};
    if (detail.source !== 'pdp' || detail.handle !== config.product || !detail.requestId) return;
    const value = refresh();
    if (value) pending.set(detail.requestId, value);
  }, true);
  document.addEventListener('cart:add:done', event => {
    const detail = event.detail || {};
    const value = pending.get(detail.requestId);
    pending.delete(detail.requestId);
    if (!value || !active() || permission() !== true || session() !== value.sid) return;
    const success = detail.ok === true && detail.reconciled !== false;
    try { posthog.capture('pdp_bnpl_ab_atc_' + (success ? 'succeeded' : 'failed'), properties(value)); } catch (error) {}
  }, true);
  document.addEventListener('visitorConsentCollected', initialize);
  document.addEventListener('visibilitychange', initialize);
  window.addEventListener('pageshow', initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
})();
